var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['tooltip', { inverted: _vm.inverted } ],style:((_vm.display) ? {
		 display: _vm.display.display,
		 left: _vm.display.left + ((_vm.inverted && this.width) ? (_vm.display.width - this.width) : 0) + 'px',
		 top: _vm.display.top + 'px',
		 width: (this.width || _vm.display.width) + 'px',
		 marginTop: _vm.tooltipTopOffset
	 } : {
		 display: 'none'
	 }),on:{"mouseover":_vm.showTooltip,"mouseout":_vm.hideTooltip}},[_c('div',{staticClass:"scroll"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }